import React, { useState, useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Switch from "@material-ui/core/Switch";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import TableRowSkeleton from "../../components/TableRowSkeleton";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
}));

const CrmPermissions = () => {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/crm/permissions");
        setUsers(data);
      } catch (err) {
        toastError(err);
      }
      setLoading(false);
    };
    fetchUsers();
  }, []);

  const handleToggle = async (userId, field, value) => {
    const previous = users;
    setUsers((prevState) =>
      prevState.map((u) => (u.id === userId ? { ...u, [field]: value } : u)),
    );
    try {
      await api.put(`/crm/permissions/${userId}`, { [field]: value });
    } catch (err) {
      setUsers(previous);
      toastError(err);
    }
  };

  return (
    <MainContainer>
      <MainHeader>
        <Title>{i18n.t("crmPermissions.title")}</Title>
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="center">
                {i18n.t("crmPermissions.columns.name")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("crmPermissions.columns.email")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("crmPermissions.columns.profile")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("crmPermissions.toggles.kanbanAccess")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("crmPermissions.toggles.manageStages")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <>
              {users.map((user) => {
                const isAdmin = user.profile === "admin";
                return (
                  <TableRow key={user.id}>
                    <TableCell align="center">{user.name}</TableCell>
                    <TableCell align="center">{user.email}</TableCell>
                    <TableCell align="center">{user.profile}</TableCell>
                    <TableCell align="center">
                      <Switch
                        color="primary"
                        checked={isAdmin ? true : !!user.crmKanbanEnabled}
                        disabled={isAdmin}
                        onChange={(e) =>
                          handleToggle(
                            user.id,
                            "crmKanbanEnabled",
                            e.target.checked,
                          )
                        }
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Switch
                        color="primary"
                        checked={isAdmin ? true : !!user.crmManageStages}
                        disabled={isAdmin}
                        onChange={(e) =>
                          handleToggle(
                            user.id,
                            "crmManageStages",
                            e.target.checked,
                          )
                        }
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
              {loading && <TableRowSkeleton columns={5} />}
            </>
          </TableBody>
        </Table>
      </Paper>
    </MainContainer>
  );
};

export default CrmPermissions;
